<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		aria-hidden="true">
		<path d="M29 11.4497L21.7677 4.09006L11.4497 4L4.09006 11.2323L4 21.5503L11.2323 28.9099L21.5503 29L28.9099 21.7677L29 11.4497Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
